import { makeStyles, Paper } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { injectIntl, useIntl, WrappedComponentProps } from "react-intl";
import { connect, ConnectedProps, useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router-dom";

import { actions as authActions } from "../../../store/ducks/auth.duck";
import { actions as myFiltersActions } from "../../../store/ducks/myFilters.duck";

import { Button, TextField, Typography } from "@mui/material";
import { LayoutSubheader } from "../../../../_metronic/layout/LayoutContext";
import ButtonWithLoader from "../../../components/ui/Buttons/ButtonWithLoader";
import { IAppState } from "../../../store/rootDuck";
import { actions as segmentActions } from "../../../store/ducks/segment.duck";
import { useSnackbar } from "notistack";

const useStyles = makeStyles(theme => ({
  paperWithForm: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    overflowX: "hidden",
  },
  form: {
    maxWidth: "800px",
    width: "100%",
    padding: theme.spacing(2),
  },
  contentContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 15,
    "& >div": {
      width: "45%",
    },
  },
  subTitle: {
    marginBottom: "15px !important",
    fontSize: "18px !important",
  },
}));

const ChangeSegmentsPage: React.FC<TPropsFromRedux & WrappedComponentProps & RouteComponentProps> = ({}) => {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch: any = useDispatch();
  const segmentTitles = useSelector((state: IAppState) => state.segment.segmentTitles);
  const loading = useSelector((state: IAppState) => state.segment.loading);
  const success = useSelector((state: IAppState) => state.segment.success);
  const error = useSelector((state: IAppState) => state.segment.error);
  const [segment1_vendor, setSegment1_vendor] = useState("");
  const [segment2_vendor, setSegment2_vendor] = useState("");
  const [segment3_vendor, setSegment3_vendor] = useState("");
  const [segment1_buyer, setSegment1_buyer] = useState("");
  const [segment2_buyer, setSegment2_buyer] = useState("");
  const [segment3_buyer, setSegment3_buyer] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (success || error) {
      enqueueSnackbar(
        success
          ? intl.formatMessage({ id: "NOTISTACK.ERRORS.SAVE_SEGMENTS" })
          : `${intl.formatMessage({ id: "NOTISTACK.ERRORS.ERROR" })} ${error}`,
        {
          variant: success ? "success" : "error",
        }
      );
      dispatch(segmentActions.clearChangeFetch());
    }
  }, [loading]);

  useEffect(() => {
    if (segmentTitles.length) {
      setSegment1_vendor(segmentTitles?.find(e => e.name === "segment1_vendor")?.text || "");
      setSegment2_vendor(segmentTitles?.find(e => e.name === "segment2_vendor")?.text || "");
      setSegment3_vendor(segmentTitles?.find(e => e.name === "segment3_vendor")?.text || "");
      setSegment1_buyer(segmentTitles?.find(e => e.name === "segment1_buyer")?.text || "");
      setSegment2_buyer(segmentTitles?.find(e => e.name === "segment2_buyer")?.text || "");
      setSegment3_buyer(segmentTitles?.find(e => e.name === "segment3_buyer")?.text || "");
    }
  }, [segmentTitles.length]);

  const handleSubmit = () => {
    dispatch(
      segmentActions.fetchChangeRequest({
        payload: { segment1_vendor, segment2_vendor, segment3_vendor, segment1_buyer, segment2_buyer, segment3_buyer },
      })
    );
  };

  return (
    <Paper className={classes.paperWithForm}>
      <LayoutSubheader
        title={`${intl.formatMessage({ id: "SUBHEADER.PARTS.EDIT" })} ${intl.formatMessage({
          id: "SUBHEADER.PARTS.SEGMENTS",
        })}`}
        breadcrumb={undefined}
        description={undefined}
      />
      <form onSubmit={handleSubmit} className={classes.form}>
        <div className={classes.contentContainer}>
          <div>
            <Typography className={classes.subTitle}>{intl.formatMessage({ id: "SUBHEADER.PARTS.SEGMENTS.VENDORS" })}</Typography>
            <TextField
              name="segment1_vendor"
              label="Сегмент 1 (продавец)"
              value={segment1_vendor}
              onChange={e => setSegment1_vendor(e.target.value)}
              sx={{
                width: "100%",
                marginBottom: 2,
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#5D78FF",
                  },
                },
              }}
            />
            <TextField
              name="segment2_vendor"
              label="Сегмент 2 (продавец)"
              value={segment2_vendor}
              onChange={e => setSegment2_vendor(e.target.value)}
              sx={{
                width: "100%",
                marginBottom: 2,
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#5D78FF",
                  },
                },
              }}
            />
            <TextField
              name="segment3_vendor"
              label="Сегмент 3 (продавец)"
              value={segment3_vendor}
              onChange={e => setSegment3_vendor(e.target.value)}
              sx={{
                width: "100%",
                marginBottom: 2,
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#5D78FF",
                  },
                },
              }}
            />
          </div>
          <div>
            <Typography className={classes.subTitle}>{intl.formatMessage({ id: "SUBHEADER.PARTS.SEGMENTS.BUYERS" })}</Typography>
            <TextField
              name="segment1_buyer"
              label="Сегмент 1 (покупатель)"
              value={segment1_buyer}
              onChange={e => setSegment1_buyer(e.target.value)}
              sx={{
                width: "100%",
                marginBottom: 2,
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#5D78FF",
                  },
                },
              }}
            />
            <TextField
              name="segment2_buyer"
              label="Сегмент 2 (покупатель)"
              value={segment2_buyer}
              onChange={e => setSegment2_buyer(e.target.value)}
              sx={{
                width: "100%",
                marginBottom: 2,
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#5D78FF",
                  },
                },
              }}
            />
            <TextField
              name="segment3_buyer"
              label="Сегмент 3 (покупатель)"
              value={segment3_buyer}
              onChange={e => setSegment3_buyer(e.target.value)}
              sx={{
                width: "100%",
                marginBottom: 2,
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#5D78FF",
                  },
                },
              }}
            />
          </div>
        </div>
        <ButtonWithLoader loading={loading} disabled={loading} onPress={handleSubmit}>
          {intl.formatMessage({ id: "ALL.BUTTONS.SAVE" })}
        </ButtonWithLoader>
      </form>
    </Paper>
  );
};

const connector = connect(
  (state: IAppState) => ({
    me: state.auth.user,
    editSuccess: state.myFilters.editSuccess,
    editError: state.myFilters.editError,
  }),
  {
    fetch: myFiltersActions.fetchRequest,
    fetchMe: authActions.fetchRequest,
    clearEdit: myFiltersActions.clearEdit,
  }
);

type TPropsFromRedux = ConnectedProps<typeof connector>;

export default connector(injectIntl(ChangeSegmentsPage));
